import {FpMessageType} from '@/modules/deals/enums/FpMessageType';
import {IMessage} from '@/models/interfaces/IMessage';
import {MinimalUser} from '@/models/user/User';

export abstract class HistoryElementDTO<DataT> implements IMessage<DataT, FpMessageType> {
  public id?: number;
  public createdDate!: string;
  public type!: FpMessageType;
  public data!: DataT;
  public dealId?: number;
  public user?: MinimalUser;
}

export class HistoryElement<DataT> extends HistoryElementDTO<DataT> {
  constructor(historyElementDTO?: HistoryElementDTO<DataT>) {
    super();
    Object.assign(this, historyElementDTO);
  }

  public get createdDateObject(): Date | null {
    return this.createdDate ? new Date(this.createdDate) : null;
  }
}
